/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconDelta = createReactComponent("delta", "IconDelta", [
  ["path", { d: "M4 20h16l-8 -16z", key: "svg-0" }]
]);

export { IconDelta as default };
//# sourceMappingURL=IconDelta.js.map
